import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import Api from '../config/Api';
import LogoImg from '../img/logo-fresenius-img.png';
import LogoTxt from '../img/logo-fresenius-txt.png';

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: (localStorage.token ? localStorage.token : sessionStorage.token),
			email: ''
		}
	}

	componentWillMount() {
		var self = this;
		if(this.props.isLogged) {
			if(this.state.token === '') {
				this.setState({
					token: (localStorage.token ? localStorage.token : sessionStorage.token)
				}, function() {
					Api.parseToken(this.state.token, function(response) {
						self.setState({
							email: response.email
						});
					});
				});
			} else {
				Api.parseToken(this.state.token, function(response) {
					self.setState({
						email: response.email
					});
				});
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		var self = this;
		if(nextProps.isLogged) {
			if(this.state.token === undefined) {
				this.setState({
					token: (localStorage.token ? localStorage.token : sessionStorage.token)
				}, function() {
					Api.parseToken(this.state.token, function(response) {
						self.setState({
							email: response.email
						});
					});
				});
			} else {
				Api.parseToken(this.state.token, function(response) {
					self.setState({
						email: response.email
					});
				});
			}
		}
	}

    render() {
    	if(this.props.isLogged) {
	        return(
	            <div className="header">
	            	<div className="row">
						<div className="col-9 col-r-12 logos">
							<img src={LogoImg} alt="Fresenius Kabi Img" className="logoImgHeader" />
							<h1>CKDOD <span>Importer Tool <i>by</i></span></h1>
							<img src={LogoTxt} alt="Fresenius Kabi Txt" className="logoTxtHeader" />
						</div>
						<div className="col-3 col-r-12">
							<ul className="headerMenu logged">
								<li className="db"><span>Logged as: </span> <strong>{this.state.email}</strong></li>
								<li><Link to="/dashboard">Dashboard</Link></li>
								<li>|</li>
								<li><Link to="/logout">Logout</Link></li>
							</ul>
						</div>
	            	</div>
	            </div>
	        );
    	} else {
    		return(
	            <div className="header">
	            	<div className="row">
						<div className="col-10 col-r-12 logos">
							<img src={LogoImg} alt="Fresenius Kabi Img" className="logoImgHeader" />
							<h1>CKDOD <span>Importer Tool <i>by</i></span></h1>
							<img src={LogoTxt} alt="Fresenius Kabi Txt" className="logoTxtHeader" />
						</div>
						<div className="col-2 col-r-12">
							<ul className="headerMenu">
								<li><Link to="/login">Login</Link></li>
							</ul>
						</div>
	            	</div>
	            </div>
	        );
    	}
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js